// src/views/Restaurant/ClientManagement/ReservationManagement/Reservations.tsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getLocalByLocalId } from '../../../../../crud/management_api/locales';
import {
  getLocalReservationConfigurationByLocalId,
} from '../../../../../crud/management_api/reservations_configuration';
import {getReservationById} from '../../../../../crud/clients_api/client_reservations';
import 'react-calendar/dist/Calendar.css';
import './Reservations.scss';
import ClientInfo from './components/ClientInfo/ClientInfo';
import FinalPage from './components/FinalPage/FinalPage';
import TimeSelector from './components/TimeSelector/TimeSelector';
import LoadingSpinner from '../../../../../components/common/LoadingSpinner';
import { ReservationFormData , Configuration, ReservationConfirmation } from './types';

type Mode = 'PlaceReservation' | 'MyReservation';

export default function Reservations() {
  const { mode, id } = useParams<{mode:Mode, id:string}>();
  const [formData, setFormData] = useState<ReservationFormData>({
    local_id:   mode==='PlaceReservation' ? id : undefined,
    numPeople:  1,
    date:       null,
    preferredHour:   null,
    preferredMinute: null,
    selectedSlot:    null,
    mesa_id:         null,
    fullName:   '',
    client_id: null,
    phone:     '',
    email:     '',
    note:      '',
  });
  const [config, setConfig] = useState<Configuration|null>(null);
  const [stage, setStage] = useState<'time'|'client'|'success'|'error'>('time');
  const [localInfo, setLocalInfo] = useState<any>(null);
  const [clientLoggedIn, setClientLoggedIn] = useState(false);
  const [reservationConfirmation, setReservationConfirmation] = useState<ReservationConfirmation|null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (mode === 'MyReservation') {
      // --- fetch existing reservation by id ---
      getReservationById(Number(id))
        .then(r => {
          setReservationConfirmation(r.data);
          setStage('success');
        })
        .catch(() => setStage('error'))
        .finally(() => setLoading(false));
    }
    else if (mode === 'PlaceReservation') {
      // --- new reservation flow ---
      Promise.all([
        getLocalByLocalId(String(id)),
        getLocalReservationConfigurationByLocalId(Number(id)),
      ])
        .then(([loc, cfg]) => {
          setLocalInfo(loc.data);
          setConfig(cfg.data.object);
        })
        .catch(() => setStage('error'))
        .finally(() => setLoading(false));

      // prefill client if logged in
      const c = localStorage.getItem('client');
      if (c) {
        const o = JSON.parse(c);
        setFormData(fd => ({
          ...fd,
          name:       o.username,
          client_id:  o.client_id,
          email:      o.email,
          phone:      o.phone_number,
        }));
        setClientLoggedIn(true);
      }
    }
    else {
      setStage('error');
      setLoading(false);
    }
  }, [mode, id]);

  if (loading)     return <LoadingSpinner text="Cargando..." />;
  if (stage==='error') return <> Algo Salio mal</>;

  return (
    <div className="reservations-container restaurant">
      <div className="reservation-form restaurant">
        {mode==='PlaceReservation' && stage==='time' && localInfo && config && (
          <TimeSelector
            localInfo={localInfo}
            config={config}
            formData={formData}
            setFormData={setFormData}
            local_id={id}
            setStage={setStage}
          />
        )}

        {mode==='PlaceReservation' && stage==='client' && (
          <ClientInfo
            formData={formData}
            setFormData={setFormData}
            localInfo={localInfo}
            clientLoggedIn={clientLoggedIn}
            setStage={setStage}
            setReservationConfirmation={setReservationConfirmation}
          />
        )}

        {stage==='success' && reservationConfirmation && (
          <FinalPage reservationConfirmation={reservationConfirmation} />
        )}

        <div className="restaurant-site-powered restaurant">
          <span>Powered by</span>
          <img
            src={`${process.env.PUBLIC_URL}/logos/Recurso 49MEDIOPUNTO.png`}
            alt="MedioPunto"
            className="powered-logo restaurant"
          />
          <span>MedioPunto</span>
        </div>
      </div>
    </div>
  );
}

